import { render, staticRenderFns } from "./SimpleAudio.vue?vue&type=template&id=4fbbe189"
import script from "./SimpleAudio.vue?vue&type=script&lang=js"
export * from "./SimpleAudio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports